"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectedHeatUsage = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
class DirectedHeatUsage extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.DIRECTED_HEAT_USAGE,
            cost: 1,
            metadata: {
                cardNumber: 'X48',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 3 heat to gain either 4 M€ or 2 plants.', (eb) => {
                        eb.heat(3).digit.startAction.megacredits(4).or().plants(2);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.availableHeat >= 3;
    }
    action(player) {
        return player.spendHeat(3, () => {
            return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Gain 4 M€', 'Gain M€', () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, 4, { log: true });
                return undefined;
            }), new SelectOption_1.SelectOption('Gain 2 plants', 'Gain plants', () => {
                player.addResource(Resources_1.Resources.PLANTS, 2, { log: true });
                return undefined;
            }));
        });
    }
}
exports.DirectedHeatUsage = DirectedHeatUsage;
//# sourceMappingURL=DirectedHeatUsage.js.map